export const initNews = ( component ) => {
	const newsBlock = component.querySelector( 'aside.news' );

	if ( !newsBlock )
	{
		return;
	}

	const newsItems = Array.from( newsBlock.querySelectorAll( 'li' ) );
	let currentItem = 1, newsInterval;

	const changeNews = () => {
		newsItems[currentItem].classList.add( 'fading' );
		currentItem = currentItem < newsItems.length - 1 ? currentItem + 1 : 1;
		newsItems[currentItem].classList.remove( 'hidden' );

		const fadingTimeout = setTimeout( () => {
			const fadedItem = newsBlock.querySelector( 'li.fading' );

			fadedItem.classList.add( 'hidden' );
			fadedItem.classList.remove( 'fading' );

			clearTimeout( fadingTimeout );
		}, 500 );
	};

	const setNewsChange = () => {
		newsInterval = setInterval( changeNews, 10000 );
		newsBlock.removeEventListener( 'mouseout', setNewsChange );
	};

	setNewsChange();
	
	newsBlock.addEventListener( 'mouseover', () => {
		clearInterval( newsInterval );
		newsBlock.addEventListener( 'mouseout', setNewsChange );
	} );
};